import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
import { AssetStorageClient, AssetStorageKeyWordDTO, FilterDTO, FilterOperator, PagedResultDTOOfAssetStorageKeyWordDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class AssetKeyWordService {

  constructor(
    private assetStorageClient: AssetStorageClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService)
  {
  }

  searchKeyWords(searchText: string): Observable<PagedResultDTOOfAssetStorageKeyWordDTO> {
    const filterDTOs = [];
    if (searchText) {
      filterDTOs.push( new FilterDTO({
        isComplex: false,
        field: 'name',
        operator: FilterOperator.Contains,
        value: searchText,
      }),);
    }

    return this.assetStorageClient.searchAssetStorageKeyWords(0, 1000, 'Name', SortDirection.Ascending, false, filterDTOs)
    .pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  addRecord(data: any): Observable<AssetStorageKeyWordDTO> {
    this.spinnerService.show()
    return this.assetStorageClient.createAssetStorageKeyWord(data).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.messages.create.success-title',
          'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.messages.create.success-message');
      }),
      finalize(() => this.spinnerService.hide()),
      catchError(err => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.messages.create.fail-title',
            'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.messages.create.fail-message', null, ErrorType.serverError);
        }
        return throwError(() => err);
      })
    );
  }

  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

}
